<!-- 平面圖列表頁面 -->
<div class="floorplan-list-container">
  <!-- 頂部工具列 -->
  <header class="page-header">
    <div class="header-left">
      <i class="fas fa-th-large"></i>
      <span class="page-title">{{ 'floorplan.list.title' | translate }}</span>
    </div>
    
    <div class="header-right">
      <!-- 顯示模式切換 -->
      <div class="view-toggle">
        <button 
          class="toggle-btn" 
          [class.active]="viewMode === 'list'"
          (click)="viewMode = 'list'"
          [title]="'floorplan.list.list_view' | translate">
          <i class="fas fa-list"></i>
        </button>
        <button 
          class="toggle-btn" 
          [class.active]="viewMode === 'grid'"
          (click)="viewMode = 'grid'"
          [title]="'floorplan.list.grid_view' | translate">
          <i class="fas fa-th"></i>
        </button>
      </div>
      
      <!-- 新增平面圖按鈕 -->
      <button class="btn btn-primary add-button" (click)="openEditor()">
        <i class="fas fa-plus"></i>
        {{ 'floorplan.list.add_button' | translate }}
      </button>
    </div>
  </header>

  <!-- 搜尋和篩選區域 -->
  <div class="filter-card">
    <div class="filter-row">
      <!-- 搜尋欄 -->
      <div class="form-group search-field">
        <label>{{ 'floorplan.list.search_label' | translate }}</label>
        <div class="input-with-icon">
          <input 
            type="text"
            class="form-control"
            [(ngModel)]="searchTerm" 
            [placeholder]="'floorplan.list.search_placeholder' | translate">
          <i class="fas fa-search input-icon"></i>
        </div>
      </div>
      
      <!-- 建築物篩選 -->
      <div class="form-group filter-field">
        <label>{{ 'floorplan.list.building_filter' | translate }}</label>
        <select class="form-control" [(ngModel)]="selectedBuilding">
          <option value="">{{ 'floorplan.list.all' | translate }}</option>
          <option *ngFor="let building of buildings" [value]="building">
            {{building}}
          </option>
        </select>
      </div>
      
      <!-- 樓層篩選 -->
      <div class="form-group filter-field">
        <label>{{ 'floorplan.list.floor_filter' | translate }}</label>
        <select class="form-control" [(ngModel)]="selectedFloor">
          <option value="">{{ 'floorplan.list.all' | translate }}</option>
          <option *ngFor="let floor of floors" [value]="floor">
            {{floor}}
          </option>
        </select>
      </div>

      <!-- 部門篩選 -->
      <div class="form-group filter-field">
        <label>{{ 'floorplan.list.department_filter' | translate }}</label>
        <select class="form-control" [(ngModel)]="selectedDepartment">
          <option value="">{{ 'floorplan.list.all' | translate }}</option>
          <option *ngFor="let dept of departments" [value]="dept.id">
            {{ formatDepartmentName(dept) }}
          </option>
        </select>
      </div>

      <!-- 清除篩選按鈕 -->
      <button class="btn btn-outline clear-filters" (click)="clearFilters()">
        <i class="fas fa-times"></i>
        {{ 'floorplan.list.clear_filters' | translate }}
      </button>
    </div>
  </div>

  <!-- 結果統計 -->
  <div class="results-info">
    <span class="result-count">
      {{ 'floorplan.list.showing_count' | translate: {filtered: filteredFloorplans.length, total: floorplans.length} }}
    </span>
  </div>

  <!-- 載入中指示器 -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
          <p>{{ 'common.loading' | translate }}</p>
  </div>

  <!-- 平面圖網格檢視 -->
  <div *ngIf="!loading && viewMode === 'grid'" class="floorplan-grid">
    <div 
      *ngFor="let floorplan of filteredFloorplans" 
      class="floorplan-card"
      (click)="openEditor(floorplan)">
      
      <!-- 平面圖預覽 -->
      <div class="floorplan-preview">
        <img [src]="floorplan.file_url" 
             alt=""
             class="preview-image"
             loading="lazy">
        
        <!-- 操作選單 -->
        <div class="card-actions">
          <button 
            class="action-menu"
            (click)="toggleDropdownMenu('card-' + floorplan.id, $event)">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          
          <div 
            class="dropdown-menu"
            [class.show]="showDropdownMenu === 'card-' + floorplan.id">
            <button class="dropdown-item" (click)="openEditor(floorplan)">
              <i class="fas fa-edit"></i>
              {{ 'common.edit' | translate }}
            </button>
            <button class="dropdown-item" (click)="duplicateFloorplan(floorplan, $event)">
              <i class="fas fa-copy"></i>
              {{ 'floorplan.list.duplicate' | translate }}
            </button>
            <button class="dropdown-item delete-action" (click)="deleteFloorplan(floorplan, $event)">
              <i class="fas fa-trash"></i>
              {{ 'common.delete' | translate }}
            </button>
          </div>
        </div>
      </div>
      
      <!-- 平面圖資訊 -->
      <div class="floorplan-info">
        <h3 class="floorplan-name">{{floorplan.name}}</h3>
        <p class="floorplan-description" *ngIf="floorplan.description">
          {{floorplan.description}}
        </p>
        
        <div class="floorplan-meta">
          <div class="meta-item" *ngIf="floorplan.building_name">
            <i class="fas fa-building"></i>
            <span>{{floorplan.building_name}}</span>
          </div>

          <div class="meta-item" *ngIf="floorplan.departmentName">
            <i class="fas fa-sitemap"></i>
            <span>{{floorplan.departmentName}}</span>
          </div>

          <div class="meta-item">
            <i class="fas fa-ruler"></i>
            <span>{{floorplan.width_pixels}} × {{floorplan.height_pixels}}</span>
          </div>

          <div class="meta-item">
            <i class="fas fa-database"></i>
            <span>{{formatFileSize(floorplan.file_size)}}</span>
          </div>

          <div class="meta-item" *ngIf="floorplan.scale_ratio">
            <i class="fas fa-expand-arrows-alt"></i>
            <span>1:{{floorplan.scale_ratio}}</span>
          </div>
        </div>
        
        <div class="floorplan-dates">
          <small class="update-time">
            {{ 'floorplan.list.updated_on' | translate: {date: formatDate(floorplan.updatedAt)} }}
          </small>
        </div>
      </div>
    </div>
  </div>

  <!-- 平面圖表格檢視 -->
  <div *ngIf="!loading && viewMode === 'list'" class="floorplan-table">
    <div class="table-container">
      <table class="table table-hover">
        <thead>
          <tr>
            <th width="80">{{ 'floorplan.list.preview' | translate }}</th>
            <th>{{ 'floorplan.list.name' | translate }}</th>
            <th>{{ 'floorplan.list.building' | translate }}</th>
            <th>{{ 'floorplan.list.floor' | translate }}</th>
            <th>{{ 'floorplan.list.department' | translate }}</th>
            <th>{{ 'floorplan.list.dimensions' | translate }}</th>
            <th>{{ 'floorplan.list.file_size' | translate }}</th>
            <th>{{ 'floorplan.list.scale' | translate }}</th>
            <th>{{ 'floorplan.list.updated_at' | translate }}</th>
            <th width="80">{{ 'common.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let floorplan of filteredFloorplans" 
              class="floorplan-table-row"
              (click)="openEditor(floorplan)">
            
            <!-- 縮圖 -->
            <td>
              <img [src]="floorplan.file_url" 
                   alt=""
                   class="table-thumbnail">
            </td>
            
            <!-- 平面圖名稱 -->
            <td>
              <a class="table-title-link" 
                 [routerLink]="['/floorplan/editor', floorplan.id]" 
                 target="_blank"
                 (click)="$event.stopPropagation()">
                {{floorplan.name}}
              </a>
              <div class="table-description" *ngIf="floorplan.description">
                {{floorplan.description}}
              </div>
            </td>
            
            <!-- 建築物 -->
            <td>
              <span *ngIf="floorplan.building_name">{{floorplan.building_name}}</span>
              <span *ngIf="!floorplan.building_name" class="text-muted">-</span>
            </td>
            
            <!-- 樓層 -->
            <td>
              <span class="floor-chip">{{floorplan.floor_level}}</span>
            </td>

            <!-- 所屬部門 -->
            <td>
              <span *ngIf="floorplan.departmentName">{{floorplan.departmentName}}</span>
              <span *ngIf="!floorplan.departmentName" class="text-muted">-</span>
            </td>

            <!-- 尺寸 -->
            <td>
              {{floorplan.width_pixels}} × {{floorplan.height_pixels}}
            </td>
            
            <!-- 檔案大小 -->
            <td>
              {{formatFileSize(floorplan.file_size)}}
            </td>
            
            <!-- 比例 -->
            <td>
              <span *ngIf="floorplan.scale_ratio">1:{{floorplan.scale_ratio}}</span>
              <span *ngIf="!floorplan.scale_ratio" class="text-muted">-</span>
            </td>
            
            <!-- 更新時間 -->
            <td>
              {{formatDate(floorplan.updatedAt)}}
            </td>
            
            <!-- 操作按鈕 -->
            <td>
              <button 
                class="table-action-btn"
                (click)="toggleDropdownMenu('table-' + floorplan.id, $event)">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              
              <div 
                class="dropdown-menu"
                [class.show]="showDropdownMenu === 'table-' + floorplan.id">
                <button class="dropdown-item" (click)="openEditor(floorplan)">
                  <i class="fas fa-edit"></i>
                  {{ 'common.edit' | translate }}
                </button>
                <button class="dropdown-item" (click)="duplicateFloorplan(floorplan, $event)">
                  <i class="fas fa-copy"></i>
                  {{ 'floorplan.list.duplicate' | translate }}
                </button>
                <button class="dropdown-item delete-action" (click)="deleteFloorplan(floorplan, $event)">
                  <i class="fas fa-trash"></i>
                  {{ 'common.delete' | translate }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 空狀態 -->
  <div *ngIf="!loading && filteredFloorplans.length === 0" class="empty-state">
    <i class="fas fa-th-large empty-icon"></i>
    <h3>{{ 'floorplan.list.no_results' | translate }}</h3>
    <p *ngIf="searchTerm || selectedBuilding || selectedFloor; else noFloorplans">
      {{ 'floorplan.list.no_results_filter' | translate }}
    </p>
    <ng-template #noFloorplans>
      <p>{{ 'floorplan.list.no_floorplans' | translate }}</p>
    </ng-template>
    
    <button class="btn btn-primary" (click)="openEditor()" *ngIf="!searchTerm && !selectedBuilding && !selectedFloor">
      <i class="fas fa-plus"></i>
      {{ 'floorplan.list.add_first' | translate }}
    </button>
    
    <button class="btn btn-outline" (click)="clearFilters()" *ngIf="searchTerm || selectedBuilding || selectedFloor">
      <i class="fas fa-times"></i>
      {{ 'floorplan.list.clear_filters' | translate }}
    </button>
  </div>
</div>

<!-- 通知訊息 -->
<div class="notification" [class.show]="notification.show" [ngClass]="'notification-' + notification.type">
  <div class="notification-content">
    <span class="notification-message">{{notification.message}}</span>
    <button class="notification-close" (click)="closeNotification()">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<!-- 點擊外部區域關閉下拉選單 -->
<div class="overlay" *ngIf="showDropdownMenu" (click)="hideDropdownMenu()"></div>

<!-- 新增平面圖對話框 -->
<div class="dialog-overlay" *ngIf="showAddDialog" (click)="closeAddFloorplanDialog()">
  <div class="add-floorplan-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>
        <i class="fas fa-plus"></i>
        {{ 'floorplan.dialog.add_title' | translate }}
      </h2>
      <button class="dialog-close" (click)="closeAddFloorplanDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="dialog-content">
      <!-- 檔案上傳區域 -->
      <div class="file-upload-section">
        <h4>{{ 'floorplan.dialog.upload_title' | translate }} <span class="required">*</span></h4>
        <div class="file-upload-area" 
             [class.has-file]="selectedFile"
             (click)="fileInput.click()">
          
          <input #fileInput
                 type="file"
                 accept="image/*,.pdf"
                 style="display: none"
                 (change)="onFileSelected($event)">
          
          <div *ngIf="!selectedFile" class="upload-placeholder">
            <i class="fas fa-cloud-upload-alt upload-icon"></i>
            <p class="upload-text">{{ 'floorplan.dialog.upload_instruction' | translate }}</p>
            <p class="upload-hint">{{ 'floorplan.dialog.upload_hint' | translate }}</p>
          </div>
          
          <div *ngIf="selectedFile" class="file-preview">
            <i class="file-icon" [ngClass]="selectedFile.type.startsWith('image/') ? 'fas fa-image' : 'fas fa-file-pdf'"></i>
            <div class="file-info">
              <p class="file-name">{{selectedFile.name}}</p>
              <p class="file-details">
                {{formatFileSize(selectedFile.size)}} • 
                {{selectedFile.type.startsWith('image/') ? ('floorplan.editor.image_file' | translate) : ('floorplan.editor.pdf_file' | translate)}}
              </p>
            </div>
            <button class="remove-file" (click)="selectedFile = null; $event.stopPropagation()">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 基本資訊 -->
      <div class="form-section">
        <h4>{{ 'floorplan.dialog.basic_info' | translate }}</h4>

        <div class="form-group full-width">
          <label>{{ 'floorplan.dialog.name_label' | translate }} <span class="required">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newFloorplan.name"
            [placeholder]="'floorplan.editor.name_placeholder' | translate"
            maxlength="100"
            required>
          <small class="form-hint">{{newFloorplan.name.length}}/100</small>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label>{{ 'floorplan.dialog.building_label' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newFloorplan.building_name"
              [placeholder]="'floorplan.editor.building_placeholder' | translate"
              maxlength="50">
          </div>

          <div class="form-group half-width">
            <label>{{ 'floorplan.dialog.floor_label' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newFloorplan.floor_level"
              [placeholder]="'floorplan.editor.floor_placeholder' | translate"
              maxlength="10">
          </div>
        </div>

        <div class="form-group full-width">
          <label>{{ 'floorplan.dialog.department_label' | translate }}</label>
          <select
            class="form-control"
            [(ngModel)]="newFloorplan.departmentId"
            (ngModelChange)="onDepartmentChange($event)">
            <option value="">{{ 'floorplan.dialog.department_select' | translate }}</option>
            <option *ngFor="let dept of departments" [value]="dept.id">{{ formatDepartmentName(dept) }}</option>
          </select>
        </div>

        <div class="form-group full-width">
          <label>{{ 'floorplan.dialog.description_label' | translate }}</label>
          <textarea
            class="form-control"
            [(ngModel)]="newFloorplan.description"
            [placeholder]="'floorplan.editor.description_placeholder' | translate"
            rows="3"
            maxlength="500"></textarea>
          <small class="form-hint">{{(newFloorplan.description || '').length}}/500</small>
        </div>
      </div>

      <!-- 尺寸與比例 -->
      <div class="form-section">
        <h4>{{ 'floorplan.dialog.dimensions_title' | translate }}</h4>
        <p class="section-hint">{{ 'floorplan.editor.scale_hint' | translate }}</p>
        
        <div class="form-row">
          <div class="form-group quarter-width">
            <label>{{ 'floorplan.dialog.scale_label' | translate }}</label>
            <input 
              type="number"
              class="form-control"
              [(ngModel)]="newFloorplan.scale_ratio"
              placeholder="100"
              min="1">
            <small class="form-hint">1:{{newFloorplan.scale_ratio || '?'}}</small>
          </div>
          
          <div class="form-group quarter-width">
            <label>{{ 'floorplan.dialog.unit_label' | translate }}</label>
            <select class="form-control" [(ngModel)]="newFloorplan.scale_unit">
              <option value="cm">{{ 'floorplan.editor.unit_cm' | translate }}</option>
              <option value="m">{{ 'floorplan.editor.unit_m' | translate }}</option>
            </select>
          </div>
          
          <div class="form-group quarter-width">
            <label>{{ 'floorplan.editor.real_width' | translate }}</label>
            <input 
              type="number"
              class="form-control"
              [(ngModel)]="newFloorplan.real_width"
              [placeholder]="newFloorplan.scale_unit === 'cm' ? '2000' : '20'"
              min="0.1"
              step="0.1">
          </div>
          
          <div class="form-group quarter-width">
            <label>{{ 'floorplan.editor.real_height' | translate }}</label>
            <input 
              type="number"
              class="form-control"
              [(ngModel)]="newFloorplan.real_height"
              [placeholder]="newFloorplan.scale_unit === 'cm' ? '1500' : '15'"
              min="0.1"
              step="0.1">
          </div>
        </div>
      </div>
    </div>
    
    <div class="dialog-actions">
      <button 
        class="btn btn-outline"
        (click)="closeAddFloorplanDialog()"
        [disabled]="isUploading">
        {{ 'common.cancel' | translate }}
      </button>
      
      <button
        class="btn btn-primary"
        (click)="confirmCreateFloorplan()"
        [disabled]="!selectedFile || !newFloorplan.name.trim() || isUploading">
        <div class="spinner small" *ngIf="isUploading"></div>
        <i class="fas fa-save" *ngIf="!isUploading"></i>
        {{isUploading ? ('floorplan.editor.creating' | translate) : ('floorplan.dialog.create_button' | translate)}}
      </button>
    </div>
  </div>
</div>
